import { ClientAnalytics } from './clientAnalytics'

// ── Query execution ──
type QueryEvent =
  | 'sql:query:run'
  | 'sql:query:result'

// ── Toolbar ──
type ToolbarEvent =
  | 'sql:toolbar:add_query_to_solution'
  | 'sql:toolbar:add_viz_to_solution'
  | 'sql:toolbar:history_open'
  | 'sql:toolbar:history_select'
  | 'sql:toolbar:history_star'

// ── Visualization ──
type VizEvent =
  | 'sql:viz:create'

// ── Editor ──
type EditorEvent =
  | 'sql:editor:resize'

export type SqlAnalyticsEvent =
  | QueryEvent
  | ToolbarEvent
  | VizEvent
  | EditorEvent

export function trackSql(event: SqlAnalyticsEvent, properties?: Record<string, unknown>) {
  ClientAnalytics.track(event, properties)
}
